import React from 'react';
import { connect } from 'react-redux';

class HeaderImage extends React.Component {

    state = {
        scale: false
    };
     componentDidMount() {
        this.changeScreen();
        window.addEventListener("resize", this.changeScreen.bind(this));
    }


    changeScreen() {
        let scale = false;
        if (window.innerWidth <= 760) {
            scale = true;
        }
        this.setState({ scale })
    }
    render() {

        return (
            <div className='header-image-container row justify-content-center'>
                <img src={this.props.image} alt="" className={this.state.scale ? 'header-image-small' : 'header-image-large'} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {

    };
};

export default connect(mapStateToProps, {})(HeaderImage);